module.exports = __webpack_public_path__ + "static/img/15.7d502e78.png";